import { render, staticRenderFns } from "./productFilter.vue?vue&type=template&id=31079de7&scoped=true&"
import script from "./productFilter.vue?vue&type=script&lang=js&"
export * from "./productFilter.vue?vue&type=script&lang=js&"
import style0 from "./productFilter.vue?vue&type=style&index=0&id=31079de7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31079de7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31079de7')) {
      api.createRecord('31079de7', component.options)
    } else {
      api.reload('31079de7', component.options)
    }
    module.hot.accept("./productFilter.vue?vue&type=template&id=31079de7&scoped=true&", function () {
      api.rerender('31079de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productFilter.vue"
export default component.exports